import React, { useEffect, useState } from 'react';
import { MessageSquare, Plus, Trash2, Edit, Save, X, Info } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', message: '' });

  const load = () => api.get('/templates').then(res => setTemplates(res.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name || !form.message) return toast.error('Completá nombre y mensaje');
    try {
      if (editing) {
        await api.put(`/templates/${editing}`, form);
        toast.success('Plantilla actualizada');
      } else {
        await api.post('/templates', form);
        toast.success('Plantilla creada');
      }
      setForm({ name: '', message: '' });
      setEditing(null);
      setShowForm(false);
      load();
    } catch (err) { toast.error('Error al guardar'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Eliminar esta plantilla?')) return;
    try {
      await api.delete(`/templates/${id}`);
      toast.success('Plantilla eliminada');
      load();
    } catch (err) { toast.error('Error al eliminar'); }
  };

  const startEdit = (tpl) => {
    setForm({ name: tpl.name, message: tpl.message });
    setEditing(tpl.id);
    setShowForm(true);
  };

  const variables = ['{{nombre_negocio}}', '{{rubro}}', '{{ubicacion}}', '{{telefono}}', '{{email}}', '{{web}}'];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <MessageSquare size={24} color="var(--accent)" />
          <h1 style={{ fontSize: 26, fontWeight: 800 }}>Plantillas de WhatsApp</h1>
        </div>
        <button className="btn btn-primary" onClick={() => { setShowForm(true); setEditing(null); setForm({ name: '', message: '' }); }}>
          <Plus size={16} /> Nueva plantilla
        </button>
      </div>

      {/* Variables info */}
      <div className="card" style={{ marginBottom: 20, display: 'flex', alignItems: 'flex-start', gap: 10 }}>
        <Info size={18} color="var(--accent)" style={{ marginTop: 2, flexShrink: 0 }} />
        <div>
          <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>
            Usá variables dinámicas en tus mensajes que se reemplazan automáticamente con los datos del lead:
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {variables.map(v => (
              <code key={v} style={{ background: 'var(--bg-primary)', padding: '3px 10px', borderRadius: 6, fontSize: 12, color: 'var(--accent)' }}>
                {v}
              </code>
            ))}
          </div>
        </div>
      </div>

      {/* Templates list */}
      <div style={{ display: 'grid', gap: 12 }}>
        {templates.map(tpl => (
          <div key={tpl.id} className="card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <h3 style={{ fontSize: 15, fontWeight: 700 }}>{tpl.name}</h3>
                {tpl.is_default === 1 && (
                  <span className="badge" style={{ background: 'var(--accent-glow)', color: 'var(--accent)', fontSize: 10 }}>DEFAULT</span>
                )}
              </div>
              <p style={{ fontSize: 14, color: 'var(--text-secondary)', background: 'var(--bg-secondary)', padding: 12, borderRadius: 8, whiteSpace: 'pre-wrap' }}>
                {tpl.message}
              </p>
            </div>
            <div style={{ display: 'flex', gap: 4, marginLeft: 12 }}>
              <button className="btn btn-ghost btn-sm" onClick={() => startEdit(tpl)}><Edit size={14} /></button>
              <button className="btn btn-ghost btn-sm" onClick={() => handleDelete(tpl.id)}><Trash2 size={14} color="var(--danger)" /></button>
            </div>
          </div>
        ))}
      </div>

      {/* Form Modal */}
      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>{editing ? 'Editar plantilla' : 'Nueva plantilla'}</h2>
            <div className="form-group">
              <label>Nombre</label>
              <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Ej: Primer contacto" />
            </div>
            <div className="form-group">
              <label>Mensaje</label>
              <textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})}
                rows={5} placeholder="Hola, ¿estoy hablando con {{nombre_negocio}}?" style={{ resize: 'vertical' }} />
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 16 }}>
              {variables.map(v => (
                <button key={v} className="btn btn-secondary btn-sm" style={{ fontSize: 11 }}
                  onClick={() => setForm({...form, message: form.message + v})}>
                  + {v}
                </button>
              ))}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <button className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={save}><Save size={14} /> Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
